module.exports = __webpack_public_path__ + "img/filter-list2.e1fdeb6c.gif";